export const IMG = {
  pellets: "/images/pellets.jpeg",
  logs: "https://images.unsplash.com/photo-1617615181070-ab4788da6d03?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  forest: "https://images.unsplash.com/photo-1578347604204-a5ae063847e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fire: "https://images.unsplash.com/photo-1543005472-1b1d37fa4eae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  founder: "https://images.unsplash.com/photo-1581089789966-df27db014448?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  truck: "https://images.unsplash.com/photo-1779517226273-bcf843b759b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bag_tupellet: "/images/pellet-conifera-spagnolo.jpg",
  bag_gold: "/images/pellet-faggio-abete.jpg",
  bag_platin: "/images/pellet-abete-platin.jpg",
};

export const NAV = [
  { label: "Prodotti", href: "#prodotti" },
  { label: "Marchi", href: "#marchi" },
  { label: "Esperienza", href: "#esperienza" },
  { label: "Canali", href: "#canali" },
  { label: "Gruppi d'Acquisto", href: "#gruppi" },
];
